import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MoveState {
  loading: boolean;
  success: boolean;
  error: string | null;
  moveItems: Array<{ id: string; name: string; type: string }>;
  destinationFolderId: string | null;
  responseMove: any;
  updateLabelLoading?: boolean;
  updateLabelSuccess?: boolean;
  updateLabelError?: string | null;
  updatedLabel?: any | null;
  responseUpdateLabel?: any | null;
  downloadFolderLoading?: boolean;
  downloadFolderSuccess?: boolean;
  downloadFolderError?: string | null;
  downloadUrl?: string | null;
}

const initialState: MoveState = {
  loading: false,
  success: false,
  error: null,
  moveItems: [],
  destinationFolderId: null,
  responseMove: null,
  updateLabelLoading: false,
  updateLabelSuccess: false,
  updateLabelError: null,
  updatedLabel: null,
  responseUpdateLabel: null,
  downloadFolderLoading: false,
  downloadFolderSuccess: false,
  downloadFolderError: null,
  downloadUrl: null,
};

const moveSlice = createSlice({
  name: "move",
  initialState,
  reducers: {
    // Action để bắt đầu quá trình move
    moveItemsStart: (
      state,
      action: PayloadAction<{
        fileIds: string[];
        folderIds: string[];
        destinationFolderId: string;
      }>
    ) => {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.destinationFolderId = action.payload.destinationFolderId;
    },
    // Action khi move thành công
    moveItemsSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.responseMove = action.payload;
      state.moveItems = [];
      state.destinationFolderId = null;
    },
    // Action khi move thất bại
    moveItemsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    // Action reset state
    resetMoveState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.moveItems = [];
      state.destinationFolderId = null;
      state.responseMove = null;
      state.updateLabelLoading = false;
      state.updateLabelSuccess = false;
      state.updateLabelError = null;
      state.updatedLabel = null;
      state.responseUpdateLabel = null;
      state.downloadFolderLoading = false;
      state.downloadFolderSuccess = false;
      state.downloadFolderError = null;
      state.downloadUrl = null;
    },

    // Update Label actions
    updateLabelRequest: (
      state,
      action: PayloadAction<{
        labelId: string;
        parentId?: string;
      }>
    ) => {
      state.updateLabelLoading = true;
      state.updateLabelSuccess = false;
      state.updateLabelError = null;
      state.updatedLabel = null;
      state.responseUpdateLabel = null;
    },
    updateLabelSuccess: (state, action: PayloadAction<any>) => {
      state.updateLabelLoading = false;
      state.updateLabelSuccess = true;
      state.updateLabelError = null;
      state.updatedLabel = action.payload;
      state.responseUpdateLabel = action.payload;
    },
    updateLabelFailure: (state, action: PayloadAction<string>) => {
      state.updateLabelLoading = false;
      state.updateLabelSuccess = false;
      state.updateLabelError = action.payload;
      state.updatedLabel = null;
      state.responseUpdateLabel = null;
    },
    resetUpdateLabelState: (state) => {
      state.updateLabelLoading = false;
      state.updateLabelSuccess = false;
      state.updateLabelError = null;
      state.updatedLabel = null;
      state.responseUpdateLabel = null;
    },

    // Download folder actions
    downloadFolderRequest: (
      state,
      action: PayloadAction<{
        labelId: string;
        folderName: string;
        includeSubfolders?: boolean;
      }>
    ) => {
      state.downloadFolderLoading = true;
      state.downloadFolderSuccess = false;
      state.downloadFolderError = null;
      state.downloadUrl = null;
    },
    downloadFolderSuccess: (state, action: PayloadAction<string>) => {
      state.downloadFolderLoading = false;
      state.downloadFolderSuccess = true;
      state.downloadFolderError = null;
      state.downloadUrl = action.payload;
    },
    downloadFolderFailure: (state, action: PayloadAction<string>) => {
      state.downloadFolderLoading = false;
      state.downloadFolderSuccess = false;
      state.downloadFolderError = action.payload;
      state.downloadUrl = null;
    },
    resetDownloadFolderState: (state) => {
      state.downloadFolderLoading = false;
      state.downloadFolderSuccess = false;
      state.downloadFolderError = null;
      state.downloadUrl = null;
    },
  },
});

export const moveActions = moveSlice.actions;
export default moveSlice.reducer;
